import { Command } from './types.js';

/** Language constants. */
export const Lang: Record<Command, string> = Object.freeze({
  [Command.CONTROL_GROUP_NEXT]: 'Next preset group',
  [Command.CONTROL_GROUP_PREV]: 'Previous preset group',
  [Command.CONTROL_PRESET_01]: 'Preset 1',
  [Command.CONTROL_PRESET_02]: 'Preset 2',
  [Command.CONTROL_PRESET_03]: 'Preset 3',
  [Command.CONTROL_PRESET_04]: 'Preset 4',
  [Command.CONTROL_PRESET_05]: 'Preset 5',
  [Command.CONTROL_PRESET_06]: 'Preset 6',
  [Command.CONTROL_PRESET_07]: 'Preset 7',
  [Command.CONTROL_PRESET_08]: 'Preset 8',
  [Command.CONTROL_PRESET_09]: 'Preset 9',
  [Command.CONTROL_PRESET_10]: 'Preset 10',
  [Command.CONTROL_PRESET_ADD]: 'Add Preset',
  [Command.FOCUS_FAR]: 'Focus far',
  [Command.FOCUS_NEAR]: 'Focus near',
  [Command.FOCUS_ONE_PUSH]: 'One-push focus',
  [Command.FOCUS_MODE]: 'Toggle focus mode',
  [Command.FOCUS_STOP]: 'Stop focus',
  [Command.TEMPO_PT_TOGGLE]: 'Toggle pan/tilt fixed <-> variable',
  [Command.PACE_PT_DOWN]: 'Increase pan/tilt speed',
  [Command.PACE_PT_UP]: 'Decrease pan/tilt speed up',
  [Command.PACE_ZOOM_DOWN]: 'Increase zoom speed',
  [Command.PACE_ZOOM_UP]: 'Decrease zoom speed',
  [Command.PTZ_PAN]: 'Pan Camera (left/right)',
  [Command.PTZ_PAN_LEFT]: 'Pan left',
  [Command.PTZ_PAN_MAX]: 'Quick pan right',
  [Command.PTZ_PAN_MIN]: 'Quick pan len',
  [Command.PTZ_PAN_RIGHT]: 'Pan right',
  [Command.PTZ_STOP]: 'Stop camera movement',
  [Command.PTZ_TILT]: 'Tilt Camera (up/down)',
  [Command.PTZ_TILT_DOWN]: 'Tilt down',
  [Command.PTZ_TILT_MAX]: 'Quick tilt up',
  [Command.PTZ_TILT_MIN]: 'Quick tilt down',
  [Command.PTZ_TILT_UP]: 'Tilt up',
  [Command.PTZ_ZOOM]: 'Zoom Camera (in/out)',
  [Command.PTZ_ZOOM_IN]: 'Zoom in',
  [Command.PTZ_ZOOM_LOCK]: 'Toggle zoom lock',
  [Command.PTZ_ZOOM_MAX]: 'Quick zoom in',
  [Command.PTZ_ZOOM_MIN]: 'Quick zoom out',
  [Command.PTZ_ZOOM_OUT]: 'Zoom out',
  [Command.QUICK_PAN_LEFT]: 'Quick Shots: Pan left',
  [Command.QUICK_PAN_RIGHT]: 'Quick Shots: Pan right',
  [Command.QUICK_STOP]: 'Quick Shots: Stop all',
  [Command.QUICK_TILT_DOWN]: 'Quick Shots: Tilt down',
  [Command.QUICK_TILT_UP]: 'Quick Shots: Tilt up',
  [Command.QUICK_ZOOM_IN]: 'Quick Shots: Zoom in',
  [Command.QUICK_ZOOM_OUT]: 'Quick Shots: Zoom out',
  [Command.TOOL_NEXT]: 'Next tool',
  [Command.TOOL_PREV]: 'Previous tool',
  [Command.TOOL_CENTER]: 'Click to center',
  [Command.TOOL_FAST_FRAME]: 'Fast frame',
  [Command.TOOL_CINE_CENTER]: 'Cine center',
  [Command.TOOL_CINE_FRAME]: 'Cine frame',
  [Command.TOOL_JOYSTICK_TRIGGER]: 'Activate joystick',
  [Command.TOOL_JOYSTICK]: 'Joystick',
  [Command.TOOL_TRACKING]: 'Auto tracking',
  [Command.TOOL_ZOOM]: 'Move',
  [Command.TRAY_BOTTOM_TAB]: 'Show presets tab',
  [Command.TRAY_LEFT_TAB]: 'Toggle Audio/Video tab',
  [Command.TRAY_RIGHT_TAB]: 'Toggle Control/Image tab',
  [Command.VIDEO_ARRANGEMENT]: 'Toggle video arrangement',
  [Command.VIDEO_SOURCE_01]: 'Switch to Source 1',
  [Command.VIDEO_SOURCE_02]: 'Switch to Source 2',
  [Command.VIDEO_SOURCE_03]: 'Switch to Source 3',
  [Command.VIDEO_SOURCE_04]: 'Switch to Source 4',
  [Command.VIDEO_SOURCE_05]: 'Switch to Source 5',
  [Command.VIDEO_SOURCE_06]: 'Switch to Source 6',
  [Command.VIDEO_SOURCE_07]: 'Switch to Source 7',
  [Command.VIDEO_SOURCE_08]: 'Switch to Source 8',
  [Command.VIDEO_SOURCE_09]: 'Switch to Source 9',
  [Command.VIDEO_SOURCE_10]: 'Switch to Source 10',
  [Command.VIDEO_SOURCE_NEXT]: 'Next video source',
  [Command.VIDEO_SOURCE_PREV]: 'Previous video source',
  [Command.PT_SPEED_UP]: 'Increase pan/tilt speed',
  [Command.PT_SPEED_DOWN]: 'Decrease pan/tilt speed'
});
